import { staffModule } from '../store/moduleName'
import signingApi from '../api/esign/signing'
import { WORKFLOW_ACTION_TYPE, APP_CODE_STATUS } from '../constant/constant'
// import g2eApi from '../api/hr/g2e'
import i18n from '../i18n'
// import { timestampToYyyyMmDdHhMmSs } from '../utils/datetimeUtil'

export const esignMethod = {
  data () {
    return {
      esignAddLoading: {},
      esignRemoveLoading: false
    }
  },
  methods: {
    addToSigningCart: async function (task, staff, formMeta, workflowActionType = WORKFLOW_ACTION_TYPE.AGREE) {
      let formMetaMap = {
        appStatusCode: APP_CODE_STATUS[workflowActionType]
        // modifiedBy: staff.staffCode,
        // modifiedTime: timestampToYyyyMmDdHhMmSs(Date.now())
      }
      if (formMeta) {
        formMetaMap = { ...formMetaMap, ...formMeta }
      }
      // let user = null
      let body = {
        action: workflowActionType,
        // message: task.newMessage,
        // message: staff.chinName + ': ' + this.$t('eSign.AgreeAndSubmit'),
        message: task.opinion,
        workItemId: task.id,
        formMetaMap: formMetaMap,
        emailNotificationId: null,
        staffEmailAddress: null,
        staffName: null,
        lang: i18n.locale
      }
      if (task.defaultNextEuid && !task.defaultNextEuid.startsWith('E')) {
        body.assignedToGroupId = task.defaultNextEuid
      } else {
        body.assignedToEuid = task.defaultNextEuid
      }
      this.$set(this.esignAddLoading, [task.id], true) // Handle dynamic add field problem https://vuejs.org/v2/guide/reactivity.html

      if (task.isFinalStep) {
        if (workflowActionType === WORKFLOW_ACTION_TYPE.AGREE) {
          workflowActionType = WORKFLOW_ACTION_TYPE.APPROVE
          body.message = this.$chPtObjData('defaultCommentChinDesc', task)
        }
        // let staffName = null
        // body.message = staff.chinName + ': ' + this.$t('eSign.Approval')
        body.nextEuid = null
        body.action = workflowActionType
        body.formMetaMap.appStatusCode = APP_CODE_STATUS[workflowActionType]
        body.emailNotificationId = 2
        // if (this.workItem.businessCode !== BUSINESS_CODE.OFICIO) {
        //   await g2eApi.searchStaff(resp => {
        //     if (resp[0].chinName) {
        //       staffName = resp[0].chinName + ' ' + resp[0].portName
        //     } else {
        //       staffName = resp[0].portName
        //     }
        //     body.staffEmailAddress = resp[0].email
        //     body.staffName = staffName
        //   }, null, task.formAttribute.applicant)
        // }
      }

      signingApi.addTaskListSigningTask(cb => {
        if (cb.status === 201 || cb.status === 200) {
          task.isAddedToSigningCart = true
          // this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('SigningCart.AddItem.SuccessMessage'))
          this.$store.dispatch(staffModule + '/countSigningCartItem')
          // call signingCart to recalculate the number of signing task
        }
        this.$set(this.esignAddLoading, [task.id], false) // Handle dynamic add field problem https://vuejs.org/v2/guide/reactivity.html
        // console.log('esignAddLoading: ' + this.esignAddLoading[task.id])
        // return false // for disable loading
      }, task.formAttribute.formCode, this.workItem.businessCode, task.signatureFieldName, task.commentFieldName, body)
    },

    addAllToSigningCart: function (taskList, staff) {
      taskList.forEach(task => {
        if (!task.isAddedToSigningCart) {
          this.addToSigningCart(task, staff)
        }
      })
    },

    removeSigningFromCart: function (task) {
      this.esignRemoveLoading = true

      signingApi.removeSigningTask(cb => {
        if (cb.status === 201 || cb.status === 200) {
          task.isAddedToSigningCart = false
          // this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('SigningCart.RemoveItem.SuccessMessage'))
          this.$store.dispatch(staffModule + '/countSigningCartItem')
          // call signingCart to recalculate the number of signing task
        }
        this.esignRemoveLoading = false
      }, task.formAttribute.formCode)
    }
  }
}
